import {
  Box,
  Card,
  Dialog,
  DialogContent,
  AlertColor,
  Grid,
} from '@mui/material';
import $ from 'jquery';
import { createRef, useContext, useEffect, useRef, useState } from 'react';
import {
  addResponse,
  fetchFormJSON,
  getRecordById,
  questionnaireresponsePost,
} from '../../services/configApi/forms/FormBuilder/FormBuilderServices';
import { useLocation } from 'react-router-dom';
import ButtonComponent from '../../components/formlib/ButtonComponent';
import SnackBarComponent from '../../components/formlib/SnackBarComponent';
import { usePDF } from 'react-to-pdf';
import {
  AddQuestionFormRender,
  CreateResponse,
  DynamicQuestion,
  QuestionnaireintakeResponse,
  ResponseList,
} from '../../utils/type';
import MediumTypography from '../../components/formlib/MediumTypography';
import { ReactComponent as DeleteIcon } from '../../assets/images/redDeleteIcon.svg';
import { ReactComponent as TrashIcon } from '../../assets/images/trashIcon.svg';
import { LoaderContext, LoaderContextType } from '../../layouts/AppSidebar';
import ModalPopup from '../../components/formlib/ModalPopup';
import { Formik, FormikProps } from 'formik';
import Textinput from '../../components/formlib/Textinput';
import * as Yup from 'yup';
import { ResponseItem } from '../../services/ApiResponseHandler';
import {
  DownloadClientFilesResponse,
  getClientFilesUrl,
} from '../../services/configApi/clientFiles/clientFilesProvider';
window.jQuery = $;
window.$ = $;

require('formBuilder/dist/form-render.min');

type MyErrorType = {
  message: string;
};

declare global {
  interface JQuery {
    formRender: (data: string | object) => string | object;
  }
}

const initialState: CreateResponse = {
  id: '',
  formId: '',
  response: [],
};
/* eslint-disable */
let formRender;

interface ButtonProps {
  mainId?: string;
  id?: string | number | undefined;
  name?: string | undefined;
  clientId?: string | null;
  saveCallback?: () => void;
  deleteRecord?: () => void;
  deleteModal?: boolean;
  setDeleteModal?: () => void;
  onOk?: () => void;
  newForm?: boolean;
  className?: string;
  forms?: ResponseList[];
  hasEditPermission?: boolean;
}

const FormRender: React.FC<ButtonProps> = (props) => {
  const {
    id,
    name,
    clientId,
    deleteRecord,
    saveCallback,
    deleteModal,
    setDeleteModal,
    onOk,
    newForm,
    className,
    mainId,
    forms,
    hasEditPermission,
  } = props;
  const location = useLocation();

  const initialValues: AddQuestionFormRender = {
    questionName: '',
  };
  const formRef = useRef<FormikProps<AddQuestionFormRender>>(null);
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [question, setQuestion] = useState('');
  const [list, setList] = useState<DynamicQuestion[]>([]);
  const [dynamicData, setDynamicData] = useState([]);
  const [toastrDefaultMessage, setToastrDefaultMessage] = useState('');
  const [toastrId, setToastrId] = useState('');
  const [toastrVariable, setToastrVariable] = useState<AlertColor>('info');
  const [responseDetails, setResponseDetails] = useState<CreateResponse[]>([
    initialState,
  ]);
  const [open, setOpen] = useState(false);
  const fb = createRef<HTMLDivElement>();
  const { toggleLoader } = useContext(LoaderContext) as LoaderContextType;
  const [othersObject, setOthersObject] = useState<ResponseList>();
  const [defaultObject, setDefaultObject] = useState<ResponseList>();
  const [cancelModal, setCancelModal] = useState(false);
  const navParams = location.state;
  const { toPDF, targetRef } = usePDF({ filename: `${name}.pdf` });
  useEffect(() => {
    toggleLoader(true);
    getFormData();
  }, []);

  useEffect(() => {
    if (!hasEditPermission) {
      const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Tab') {
          e.preventDefault();
        }
      };
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [hasEditPermission]);

  const getFormData = () => {
    if (id) {
      getRecordById(id)
        .then((response) => {
          fetchResponseTemplate(response);
        })
        .catch((error) => {
          setOpen(true);
          setToastrVariable('error');
          setToastrId(error.message);
          setToastrDefaultMessage(error.message);
          toggleLoader(false);
        });
    }
  };

  useEffect(() => {
    const others = forms && forms.filter((item) => item.type === 'OTHERS');
    setOthersObject(others && others[0]);

    const defaults = forms && forms.filter((item) => item.type === 'Default');
    setDefaultObject(defaults && defaults[0]);
  }, []);

  useEffect(() => {
    if (!newForm) {
      getQuestionnaireRenderresponse(othersObject?.responseUploadUrl);
      getAdditionalQuestionsResponse(defaultObject?.responseUploadUrl);
    }
  }, [othersObject, defaultObject]);

  const downloadFunction = async (url: string) => {
    const filteredName = url.split('client-repo/')[1].split('?')[0];
    try {
      const response: DownloadClientFilesResponse = await getClientFilesUrl(
        filteredName,
      );
      return response;
    } catch (error) {
      const typedError = error as MyErrorType;
      setToastrVariable('error');
      setToastrId(typedError.message);
      setToastrDefaultMessage(typedError.message);
      return { url: '' };
    }
  };

  const getQuestionnaireRenderresponse = async (
    responseUploadUrl: string | undefined,
  ) => {
    if (responseUploadUrl) {
      const apiResponseData: DownloadClientFilesResponse =
        await downloadFunction(responseUploadUrl);
      fetchFormTemplate(apiResponseData.url)
        .then((response) => {
          toggleLoader(false);
        })
        .catch((error) => {
          setOpen(true);
          setToastrVariable('error');
          setToastrId(error.message);
          setToastrDefaultMessage(error.message);
          toggleLoader(false);
        });
    }
  };

  const getAdditionalQuestionsResponse = async (
    responseUploadUrl: string | undefined,
  ) => {
    if (responseUploadUrl) {
      const apiResponseData: DownloadClientFilesResponse =
        await downloadFunction(responseUploadUrl);
      fetchFormTemplate2(apiResponseData.url)
        .then((response) => {
          toggleLoader(false);
        })
        .catch((error) => {
          setOpen(true);
          setToastrVariable('error');
          setToastrId(error.message);
          setToastrDefaultMessage(error.message);
          toggleLoader(false);
        });
    }
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  async function fetchFormTemplate(responseUploadUrl: string) {
    try {
      const apiResponse = await fetchFormJSON(responseUploadUrl);
      setDynamicData(apiResponse.data);
      toggleLoader(false);
    } catch (error) {
      const typedError = error as MyErrorType;
      setOpen(true);
      setToastrVariable('error');
      setToastrId(typedError.message);
      setToastrDefaultMessage(typedError.message);
      toggleLoader(false);
    }
  }

  async function fetchFormTemplate2(responseUploadUrl: string) {
    try {
      const apiResponse = await fetchFormJSON(responseUploadUrl);
      setList(apiResponse.data);
      toggleLoader(false);
    } catch (error) {
      const typedError = error as MyErrorType;
      setOpen(true);
      setToastrVariable('error');
      setToastrId(typedError.message);
      setToastrDefaultMessage(typedError.message);
      toggleLoader(false);
    }
  }

  async function fetchResponseTemplate(response: { templateUrl: string }) {
    try {
      const apiResponseData: DownloadClientFilesResponse =
        await downloadFunction(response.templateUrl);
      const apiResponse = await fetchFormJSON(apiResponseData.url);
      setDynamicData(apiResponse.data);
      toggleLoader(false);
    } catch (error) {
      const typedError = error as MyErrorType;
      setOpen(true);
      setToastrVariable('error');
      setToastrId(typedError.message);
      setToastrDefaultMessage(typedError.message);
      toggleLoader(false);
    }
  }

  useEffect(() => {
    if (!fb.current || dynamicData.length === 0) return;

    $(fb.current as HTMLDivElement).empty();

    const editModeData = {
      formData: dynamicData,
      editMode: true,
    };


    $(fb.current as HTMLDivElement)
      .formRender(editModeData);
    $(fb.current as HTMLDivElement)
      .find('.other-option')
      .on('change', function () {
        const checkbox = $(this);

        const container = checkbox.closest('.form-group');

        const otherInput = container.find('input[type="text"]');

        if (checkbox.is(':checked')) {
          otherInput.show();
        } else {
          otherInput.hide();
          otherInput.val('');
        }
      });
    $(fb.current as HTMLDivElement).on(
      'change',
      'input[type="radio"]',
      function () {
        const currentRadio = $(this);

        // Find the Other textbox in this radio group
        const otherInput = currentRadio
          .closest('.formbuilder-radio')
          .parent() // parent containing all radio options
          .find('.other-val');

        if (currentRadio.hasClass('other-option')) {
          otherInput.show();
        } else {
          otherInput.hide();
          otherInput.val('');
        }
      }
    );
    let toggleIndex = 0;

    dynamicData.forEach((field: any) => {
      if (
        field.type === 'checkbox-group' &&
        field.toggle &&
        field.values
      ) {
        field.values.forEach((value: any) => {
          const toggle =
            $(fb.current as HTMLDivElement)
              .find('.kc-toggle')
              .eq(toggleIndex);

          if (toggle.find('input').length === 0) {
            toggle.prepend(
              $('<input>', {
                type: 'checkbox',
                checked: value.selected || false,
              }),
            );
          }

          toggleIndex++;
        });
      }
    });
  }, [dynamicData]);

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    toggleLoader(true);
    addResponse(responseDetails, clientId).then(
      async (response: ResponseItem[]) => {
        setOpen(true);
        setToastrId('formBuilder.SaveResponse');
        setToastrDefaultMessage('response submitted successfully');
        setToastrVariable('success');
        if (saveCallback) {
          saveCallback();
        }

        const hardcodedId = '86d679d1-e140-49f3-9bee-d293029f3e31';
        let defaultId = '';
        let defaultId2 = '';

        response.forEach((item) => {
          if (item.formId === hardcodedId) {
            defaultId = item.responseId;
          } else {
            defaultId2 = item.responseId;
          }
        });

        const object: QuestionnaireintakeResponse = {
          id: mainId ? mainId : '',
          name: name,
          defaultResponseId: defaultId,
          questionnaireResponseId: defaultId2,
        };

        questionnaireresponsePost(object, clientId);
      },
    );
  }, [responseDetails]);
  function saveData() {
    const updatedData = [...dynamicData];
    let hasError = false;

    $(fb.current as HTMLDivElement)
      .find('.other-option:checked')
      .each(function () {
        const otherRadio = $(this);

        const otherInput = otherRadio
          .next('label')
          .find('.other-val');

        // Remove existing error
        otherInput.siblings('.other-error').remove();

        if (!otherInput.val()?.toString().trim()) {
          hasError = true;

          otherInput.after(
            `<div class="other-error" style="color:red;font-size:12px;margin-top:4px;">
            Please enter a value.
         </div>`
          );
        }
      });

    if (hasError) {
      return;
    }
    const renderedCheckboxes =
      $(fb.current as HTMLDivElement)
        .find('.kc-toggle input[type="checkbox"]');

    let checkboxIndex = 0;

    updatedData.forEach((field: any) => {

      if (
        field.type === 'checkbox-group' &&
        field.toggle &&
        field.values
      ) {
        const selectedValues: string[] = [];

        field.values.forEach((value: any) => {
          const isChecked = renderedCheckboxes
            .eq(checkboxIndex)
            .prop('checked');


          value.selected = isChecked;


          if (isChecked) {
            selectedValues.push(value.value);
          }

          checkboxIndex++;
        });


        field.userData = selectedValues;
      }


      else if (
        field.type === 'checkbox-group' &&
        !field.toggle
      ) {
        const checkedValues: string[] = [];

        field.values = field.values.map((value: any) => {
          const checkboxElement = $(fb.current as HTMLDivElement)
            .find(`input[type="checkbox"][value="${value.value}"]`);

          const isChecked = checkboxElement.prop('checked') === true;

          if (isChecked) {
            checkedValues.push(value.value);
          }

          return {
            ...value,
            selected: isChecked,
          };
        });

        // ADD THIS PART FOR OTHER OPTION
        const otherCheckbox = $(fb.current as HTMLDivElement)
          .find(`#${field.name}-other`);


        if (otherCheckbox.prop('checked')) {
          checkedValues.push(otherCheckbox.val() as string);
        }

        // keep this after adding other value
        field.userData = checkedValues;

      }


      else if (field.type === 'radio-group') {
        const selectedRadio =
          $(fb.current as HTMLDivElement)
            .find(`input[name="${field.name}"]:checked`);


        const selectedValue = selectedRadio.val();

        field.userData = selectedValue
          ? [selectedValue as string]
          : [];
      }


      else if (field.type === 'date') {
        const dateValue =
          $(`input[name="${field.name}"]`)
            .val();

        field.userData = dateValue
          ? [dateValue]
          : [];
      }

      else if (field.type === 'textarea') {
        const textValue =
          $(`textarea[name="${field.name}"]`)
            .val();

        field.userData = textValue
          ? [textValue]
          : [];
      }


      else if (
        field.type === 'text' ||
        field.type === 'number'
      ) {
        const textValue =
          $(`input[name="${field.name}"]`)
            .val();

        field.userData = textValue
          ? [textValue]
          : [];
      }
    });


    setResponseDetails([
      {
        id: othersObject?.id ? othersObject.id : '',
        formId:
          othersObject && othersObject.questionnaireId
            ? othersObject.questionnaireId
            : id,
        response: updatedData,
      },
      {
        id: defaultObject?.id ? defaultObject.id : '',
        formId: '86d679d1-e140-49f3-9bee-d293029f3e31',
        response: list,
      },
    ]);
  }

  const clearFormData = () => {
    setCancelModal(true);
  };

  const validationSchema = Yup.object({
    questionName: Yup.string().required('formBuilder.Name'),
  });

  const handleSaveQuestion = () => {
    const newQuestion = {
      id: list.length,
      question: question,
      answer: '',
    };
    setList((prevList) => [...prevList, newQuestion] as DynamicQuestion[]);
    setQuestion('');
    setModalVisible(false);
  };

  const handleDeleteQuestion = (id: string) => {
    const updatedList = list.filter((item) => item.id !== id);
    setList(updatedList);
  };

  return (
    <Box component="div" className={className}>
      <Box component="section">
        <SnackBarComponent
          open={open}
          handleClose={handleClose}
          successOrError={toastrVariable}
          labelId={toastrId}
          defaultMessageId={toastrDefaultMessage}
        />
        {dynamicData.length > 0 && (
          <Box
            component="div"
            style={{
              pointerEvents: hasEditPermission ? 'auto' : 'none',
              opacity: hasEditPermission ? 'unset' : '0.8',
            }}
          >
            <Box component="div" className="mt-md p-md bg__white">
              <Box className="rowContainer p-none">
                <Box component="div">
                  <MediumTypography
                    labelid="Intake.QuestionnaireName"
                    defaultlabel="Questionnaire name"
                    fontSize="14px"
                    fontweight={600}
                  />
                </Box>
                <Box component="div" className="pl-xs">
                  <MediumTypography
                    labelid={name}
                    defaultlabel=""
                    fontSize="14px"
                    fontweight={600}
                  />
                </Box>
              </Box>
              <Box className="pt-md">
                <Card
                  className="formCardview p-sm gray3 borderRadius4"
                  ref={targetRef}
                  sx={{
                    border: '1px solid #00C6B8',
                    background: '#ECF9F8',
                  }}
                >
                  <Box
                    component="div"
                    sx={{ wordBreak: 'break-all', wordWrap: 'break-word' }}
                  >
                    <Box ref={fb}></Box>
                  </Box>
                  {list.map((item) => (
                    <Grid container className="flex__ align__items__center">
                      <Grid item xs={6} lg={10} className="mt-lg">
                        <Box key={item.id}>
                          <Textinput
                            className="bg__white"
                            name="name"
                            labelid={item.question}
                            defaultlabelid={item.question}
                            Required={false}
                            inputProps={{
                              maxLength: 1000,
                            }}
                            handlechange={(value) => {
                              const updatedList = list.map((q) =>
                                q.id === item.id ? { ...q, answer: value } : q,
                              );
                              setList(updatedList);
                            }}
                            type="text"
                            Value={item.answer}
                            disabled={false}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={6} lg={2} className="mt-lg pt-xs pl-md">
                        <TrashIcon
                          className="cursor__pointer"
                          onClick={() => handleDeleteQuestion(item.id)}
                        />
                      </Grid>
                    </Grid>
                  ))}
                  <Grid item xs={6} lg={6}>
                    <Box
                      component="div"
                      className="flex__ text-align-end justifyContent-FlexStart mt-lg"
                    >
                      <ButtonComponent
                        className="btn-primary btn-submit mr-md"
                        variantType="outlined"
                        labelId="Intake.AddQuestionnaireExtra"
                        defaultLabelId="Add Question"
                        onClick={() => setModalVisible(true)}
                        disabled={list.length === 5}
                      />
                    </Box>
                  </Grid>
                </Card>
              </Box>
            </Box>

            <Box className="flex__ align__items__center">
              <Grid
                className="flex__ justifyContent-FlexStart pt-md pb-lg "
                container
                direction="row"
                alignItems="right"
              >
                <Grid item>
                  <Box
                    style={{
                      display: hasEditPermission ? 'auto' : 'none',
                    }}
                    className="rowContainer cursor__pointer"
                    onClick={() => {
                      if (deleteRecord) deleteRecord();
                    }}
                  >
                    <DeleteIcon />
                    <MediumTypography
                      labelid={'Intake.DeleteQuestionnaire'}
                      defaultlabel="Delete Questionnaire"
                      sxProps={{
                        marginLeft: '8px',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        color: '#EB4C60',
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
              <Grid
                className="flex__ justifyContent-FlexEnd pt-md pb-lg "
                container
                direction="row"
                alignItems="right"
              >
                {' '}
                <Grid item>
                  <ButtonComponent
                    className="btn-primary btn-cancel btn_width_90px mr-md"
                    variantType="outlined"
                    labelId="cancelText"
                    defaultLabelId="cancel"
                    onClick={clearFormData}
                  />
                  <ButtonComponent
                    className="btn-primary btn-submit btn_width_90px "
                    variantType="outlined"
                    type="submit"
                    sxProps={{
                      display: hasEditPermission ? 'auto' : 'none',
                    }}
                    labelId="formBuilder.Save"
                    defaultLabelId="Save"
                    onClick={saveData}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>
        )}
      </Box>
      {deleteModal && (
        <ModalPopup
          open={deleteModal}
          onCancel={() => {
            if (setDeleteModal) setDeleteModal();
          }}
          description="formBuilder.DeleteResponse"
          onOk={onOk}
          labelId1="Clientpage.cancelbtn"
          negativeActionLabel="cancelText"
          labelId2="Clientpage.Okbtn"
          positiveActionLabel="deleteText"
        />
      )}

      <Box component="div">
        <Dialog
          open={modalVisible}
          keepMounted
          onClose={() => ({})}
          fullWidth
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent className="p-md">
            <MediumTypography
              labelid={'Intake.EnterQuestionName'}
              defaultlabel="Add Question"
              fontweight={1000}
              textColor="#2a4241"
            />
            <Formik
              initialValues={initialValues}
              validateOnMount={true}
              innerRef={formRef}
              enableReinitialize={true}
              onSubmit={(values, actions) => {
                handleSaveQuestion();
                actions.resetForm({
                  values: { questionName: '' },
                  errors: {},
                  touched: {},
                  status: {},
                });
              }}
              validationSchema={validationSchema}
            >
              {({ handleSubmit, setFieldValue, values, errors, touched }) => (
                <Box component="div">
                  <Box component="div" className="mt-lg">
                    <Textinput
                      name="questionName"
                      labelid={'formBuilder.NameText'}
                      defaultlabelid="Name"
                      Required={true}
                      inputProps={{
                        maxLength: 100,
                      }}
                      handlechange={(value) => {
                        setQuestion(value);
                        setFieldValue('questionName', value);
                      }}
                      type="text"
                      Value={values.questionName}
                      disabled={false}
                    />
                    {errors.questionName && touched.questionName ? (
                      <Box className="loginError">
                        <MediumTypography
                          labelid={errors.questionName}
                          defaultlabel="Enter Name"
                          sxProps={{
                            color: 'red',
                            marginLeft: '10px',
                            fontSize: '14px',
                          }}
                        />
                      </Box>
                    ) : null}
                  </Box>
                  <Box>
                    <Grid
                      className="flex__ justifyContent-FlexEnd pt-lg "
                      container
                      direction="row"
                      alignItems="right"
                    >
                      <Grid item>
                        <ButtonComponent
                          className="btn-primary btn-cancel btn_width_90px mr-md"
                          variantType="outlined"
                          labelId="cancelText"
                          defaultLabelId="Cancel"
                          onClick={() => setModalVisible(false)}
                        />

                        <ButtonComponent
                          className="btn-primary btn-submit"
                          variantType="contained"
                          labelId="Add"
                          defaultLabelId="Add"
                          onClick={handleSubmit}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      </Box>

      {cancelModal && (
        <ModalPopup
          open={cancelModal}
          onCancel={() => {
            setCancelModal(false);
          }}
          description={'formUnsavedChangesMessage'}
          onOk={() => {
            if (newForm) {
              const formElement = fb.current as HTMLFormElement | null;
              if (formElement) {
                formElement.reset();
                setList([]);
              }
            } else {
              getQuestionnaireRenderresponse(othersObject?.responseUploadUrl);
              getAdditionalQuestionsResponse(defaultObject?.responseUploadUrl);
            }
            setCancelModal(false);
          }}
          labelId1="Clientpage.Nobtn"
          negativeActionLabel="cancelText"
          labelId2="Clientpage.Yesbtn"
          positiveActionLabel="deleteText"
        />
      )}
    </Box>
  );
};

export default FormRender;
